import { RootType } from "@/models/lookup-tables/lookup-tables.dto";
import { useLocationsContext } from "@/pages/configurations/locations/context/Location";
import { useLocationTypesContext } from "@/pages/configurations/locations/context/LocationType";
import { LocationType } from "@/pages/configurations/locations/models/LocationType/LocationType";
import { useRootTypeContext } from "@/pages/configurations/rootTypes/context/RootTypeContext";
import { Button, Grid } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { ColDef } from "ag-grid-community";
import { find } from "lodash-es";
import { useMemo } from "react";

type Props = {
	/*  gridRef:Function, */
	setLocationIdForEdit: Function;
	setModalEditLocation: Function;
	setLocationIdForDelete: Function;
	setModalDeleteLocation: Function;
	setModalLocationType: Function;
};

export const useTableData = ({
	setLocationIdForEdit,
	setModalEditLocation,
	setLocationIdForDelete,
	setModalDeleteLocation,
	setModalLocationType,
}: Props) => {
	const {
		state: { locations },
	} = useLocationsContext();
	const {
		state: { locationTypes },
	} = useLocationTypesContext();

	const {
		state: { rootTypes },
	} = useRootTypeContext();

	const columns: ColDef[] = [
		{
			field: "locationId",
			headerName: "#",
			width: 70,
		},
		{
			field: "locationName",
			headerName: "Name",
		},
		{
			field: "rootTypeId",
			headerName: "Root Type",
		},
		{
			field: "isActive",
			headerName: "Status",
		},
		{
			field: "sortOrder",
			headerName: "Sort Order",
		},
		{
			field: "locationTypeId",
			headerName: "Location Types",
		},
		{
			field: "Actions",
			cellRenderer: (params: any) => {
				return (
					<Grid
						container
						justifyContent="center"
						alignItems="center"
						spacing={1}
						style={{ padding: "0" }}
					>
						<Grid item md={6} xs={6} style={{ padding: "0", marginLeft: -25 }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setLocationIdForEdit(params.data.locationId);
										setModalEditLocation(true);
									})();
								}}
							>
								<EditIcon style={{ width: 16, height: 16 }} color="primary" />
							</Button>
						</Grid>
						<Grid item md={6} xs={6} style={{ padding: "0" }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setLocationIdForDelete(params.data.locationId);
										setModalDeleteLocation(true);
									})();
								}}
							>
								<DeleteIcon
									style={{ width: 16, height: 16 }}
									color="secondary"
								/>
							</Button>
						</Grid>
					</Grid>
				);
			},
			headerName: " ",
			sortable: false,
		},
	];

	const defaultColDef = useMemo(
		() => ({
			resizable: true,
			sortable: true,
			filter: true,
		}),
		[],
	);

	const locationsJson = JSON.stringify(locations);
	const rows = useMemo(() => {
		return locations.map(
			({
				locationId,
				locationName,
				rootTypeId,
				isActive,
				locationTypeId,
				sortOrder,
			}) => {
				const rootType: RootType | undefined = find(rootTypes, [
					"rootTypeId",
					rootTypeId,
				]);
				const locationType: LocationType | undefined = find(locationTypes, [
					"locationTypeId",
					locationTypeId,
				]);

				return {
					locationId,
					locationName,
					isActive: isActive ? "Active" : "Inactive",
					rootTypeId: rootType?.rootTypeName,
					locationTypeId: locationType?.locationTypeName,
					sortOrder,
					id: locationId,
				};
			},
		);
	}, [locationsJson, rootTypes]);
	return { rows, columns, defaultColDef };
};
